module.exports = __webpack_public_path__ + "img/LOGO_NBP.b7d5078b.png";